"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiCustomerResponseDto = void 0;
const types_1 = require("../../../billing-api-contractor/types");
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
let BillingApiCustomerResponseDto = class BillingApiCustomerResponseDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id плательщика",
  format: "uuid"
}), (0, class_validator_1.IsUUID)(4), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiCustomerResponseDto.prototype, "id", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Контрагент",
  format: "uuid"
}), (0, class_validator_1.IsUUID)(4), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiCustomerResponseDto.prototype, "contractorId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Платёжный провайдер.",
  format: "uuid"
}), (0, class_validator_1.IsUUID)(4), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiCustomerResponseDto.prototype, "providerId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Имя плательщика"
}), (0, class_validator_1.IsString)(), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiCustomerResponseDto.prototype, "firstName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Фамилия плательщика"
}), (0, class_validator_1.IsString)(), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiCustomerResponseDto.prototype, "lastName", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Эл. почта плательщика"
}), (0, class_validator_1.IsEmail)(), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiCustomerResponseDto.prototype, "email", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Страна плательщика"
}), (0, class_validator_1.IsString)(), (0, class_transformer_1.Expose)(), __metadata("design:type", String)], BillingApiCustomerResponseDto.prototype, "countryCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Телефон плательщика",
  nullable: true
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsPhoneNumber)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiCustomerResponseDto.prototype, "phone", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата создания"
}), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Date)], BillingApiCustomerResponseDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата обновления"
}), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Date)], BillingApiCustomerResponseDto.prototype, "updatedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Дата удаления"
}), (0, transform_iso8601_date_1.default)(), (0, class_validator_1.IsDate)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Date)], BillingApiCustomerResponseDto.prototype, "deletedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  type: () => types_1.BillingApiContractorResponseDto
}), (0, class_transformer_1.Type)(() => types_1.BillingApiContractorResponseDto), (0, class_validator_1.ValidateNested)(), (0, class_transformer_1.Expose)(), __metadata("design:type", types_1.BillingApiContractorResponseDto)], BillingApiCustomerResponseDto.prototype, "contractor", void 0);
BillingApiCustomerResponseDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiCustomerResponseDto);
exports.BillingApiCustomerResponseDto = BillingApiCustomerResponseDto;
